// firebaseClient.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFunctions } from "firebase/functions";

import {
  firebaseConfigDev,
  firebaseConfigProd,
  firebaseConfigStaging,
} from "./firebase-config";

let app = null;
let auth = null;
let functions = null;

// Environment variable: 'DEV' | 'STAGING' | 'PROD'
const env = process.env.REACT_APP_NODE_ENV_VAR || "";

let firebaseConfig;

switch (env) {
  case "PROD":
    firebaseConfig = firebaseConfigProd;
    break;
  case "STAGING":
    firebaseConfig = firebaseConfigStaging;
    break;
  case "DEV":
    firebaseConfig = firebaseConfigDev;
    break;
  default:
    firebaseConfig = {};
    break;
}

export function initFirebase() {
  if (!app) {
     app = initializeApp(firebaseConfig);
    auth = getAuth(app);
    functions = getFunctions(app, "us-central1"); 
  }
  return app;
}

export function getFirebaseAuth() {
  if (!auth) initFirebase();
  return auth;
}

export function getFirebaseApp() {
  if (!app) initFirebase();
  return app;
}

export function getFirebaseFunctions() {
  if (!functions) initFirebase();
  return functions;
}
